import { useState } from 'react';
import { Link } from 'react-router-dom';
import logoHorizontal from '../../assets/images/logo-horizontal.svg';
import watermark from '../../assets/shapes/watermark-union.svg';
import mailLink from '../../assets/icons/mail-link-illustration.svg';

export const ResetPassword = () => {
  const [resetSent, setResetSent] = useState<boolean>(false);

  const handleSubmit = () => {
    setResetSent(!resetSent);
  };

  return (
    <div className='login'>
      <div className='login__header'>
        <picture className='login__header__logo'>
          <img className='login__header__logo__img' src={logoHorizontal} alt='logo-horizontal' />
        </picture>
        <img className='login__header__watermark' src={watermark} alt='' />
      </div>
      <div className='login__box'>
        {!resetSent ? (
          <>
            <h3 className='font-h3-regular'>Reset password</h3>
            <form className='form' onSubmit={handleSubmit}>
              <p className='font-h6-regular dark-400 text-center margin-bottom-1'>
                Type in your email address and we will send you an email with instructions on how to create a new password
              </p>
              <div className='form__item'>
                <label className='font-h6-regular margin-left-1' htmlFor='email'>
                  Email
                </label>
                <input className='font-h5-regular form__item__input' type='text' />
              </div>
              <button className='button-primary font-h5-medium text-white full-width' type='submit'>
                Reset password
              </button>
              <div className='full-width-grey-300-line' />
            </form>
            <Link to='/login' className='login__box__link font-h5-regular primary-200'>
              back to Sign in
            </Link>
          </>
        ) : (
          <div className='form text-center'>
            <picture className='login__box__mail-icon margin-bottom-1'>
              <img className='login__box__mail-icon__img' src={mailLink} alt='logo-horizontal' />
            </picture>
            <h3 className='font-h3-regular margin-bottom-1'>Reset password</h3>
            <p className='font-h6-regular dark-400 text-center margin-bottom-1'>
              If the email address you put in exists in the system, an email with instructions on how to reset your password has been sent to it.{' '}
              <br /> <br /> You can close this page and resume your account recovery from that email.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
